// import Intl polyfill for Android
// See https://github.com/expo/expo/issues/6536 for this issue.
import "intl";
import { Platform } from "react-native";
if (Platform.OS === "android") {
  if (typeof (Intl as any).__disableRegExpRestore === "function") {
    (Intl as any).__disableRegExpRestore();
  }
}
import "intl/locale-data/jsonp/en";
